import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import routes from '../../../../../../components/Routes/routingMap';
import constants from '../../../../constants';
import UpdatePhotoInfoView from './UpdatePhotoInfoView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const UpdatePhotoInfoViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { procedure: procedureSelectedInfo, selectedProcedureId } = useSelector(
    (state: any) => state.procedureInformation
  );

  const handleExistRequest = () => {
    if (procedureSelectedInfo) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.updatePhoto,
          procedureSelectedInfo.currentRequestId
        )
      );
    }

    history.push(
      routes.student.procedures.categories.requests.updatephoto
        .procedureprogress
    );
  };

  useEffect(() => {
    GoogleAnalytics.writeLog(`portal-procedure-updatePhoto`, 'portal');
    // if (!procedureSelectedInfo && !isLoading) {
    const selectedRequest =
      constants.categories.requests.procedures.updatePhoto;
    dispatch(procedureActions.getProcedureInformation(selectedRequest));
    // }
  }, []);
  const selectedRequest = constants.categories.requests.procedureList.find(
    (p: any) => p.procedureId === selectedProcedureId
  );
  const [showModalConfirmation, SetShowModalConfirmation] = useState(false);
  const handleCloseModalConfirmation = () => {
    SetShowModalConfirmation(false);
  };

  const handleNewRequest = (isValid: boolean) => {
    if (procedureSelectedInfo.requestInProgress) {
      SetShowModalConfirmation(true);
    } else {
      const url =
        routes.student.procedures.categories.requests.updatephoto
          .procedureregister;

      history.push(`${url}${isValid ? '?x=true' : '?x=false'}`);
    }
  };

  const handleBack = () => history.push('/tramites/autogestionables');

  return (
    <UpdatePhotoInfoView
      selectedRequest={selectedRequest}
      handleBack={handleBack}
      handleNewRequest={handleNewRequest}
      handleExistRequest={handleExistRequest}
      handleCloseModalConfirmation={handleCloseModalConfirmation}
      procedureSelectedInfo={procedureSelectedInfo}
      showModalConfirmation={showModalConfirmation}
    />
  );
};

export default UpdatePhotoInfoViewController;
